import { useNuxtApp } from "#app";
import { useAuthStore } from "~/stores/auth";
import { hexToRgbString, resolveSchoolBrandPalette } from "~/utils/schoolBrand";

export default defineNuxtPlugin({
  name: "school-brand",
  dependsOn: ["vuetify"],
  setup() {
    const authStore = useAuthStore();

    const theme = useNuxtApp().$vuetify.theme;
    const baseTheme = theme.themes.value.teachPlusTheme;

    watch(
      () => resolveSchoolBrandPalette(authStore.user.schoolBrand),
      (palette) => {
        // Update Vuetify before consumers render, including future components
        // and teleported overlays. CSS overrides on mounted nodes miss both.
        theme.themes.value.teachPlusTheme = {
          ...baseTheme,
          colors: {
            ...baseTheme.colors,
            primary: palette.primary,
            secondary: palette.secondary,
            "primary-darken-1": palette.primaryDarken,
            "secondary-darken-1": palette.secondaryDarken,
          },
        };

        const style = document.documentElement.style;
        style.setProperty("--teachplus-brand-primary", palette.primary);
        style.setProperty("--teachplus-brand-secondary", palette.secondary);
        style.setProperty(
          "--teachplus-brand-primary-rgb",
          hexToRgbString(palette.primary),
        );
        style.setProperty(
          "--teachplus-brand-secondary-rgb",
          hexToRgbString(palette.secondary),
        );
        style.setProperty("--school-primary", palette.primary);
        style.setProperty("--school-secondary", palette.secondary);
      },
      { immediate: true, flush: "sync" },
    );
  },
});
